var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$auth.isAuthenticated())?_c('div',{staticClass:"home"},[_c('landingHeader'),_c('landingCall'),_c('landingStats'),_c('landingVideos')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }